(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-quote-form"] && !Shopify.designMode) return;
  try {
    
  // ==== Etsy-username show/hide ======================================
  (function() {
    var etsyBlock = document.getElementById('CustomQuote-EtsyBlock');
    if (!etsyBlock) return;
    var radios = document.querySelectorAll('input[name="contact[fulfillment_channel]"]');
    function sync() {
      var etsyChosen = false;
      radios.forEach(function(r) { if (r.checked && r.value === 'Etsy') etsyChosen = true; });
      etsyBlock.hidden = !etsyChosen;
    }
    radios.forEach(function(r) { r.addEventListener('change', sync); });
    sync();
  })();

  // ==== Direct-to-Drive uploader =====================================
  //
  // Coordinates with the Google Apps Script web app whose URL the store
  // owner pasted in the section settings. Flow for each submission:
  //
  //   1) User picks files (or drops them on the dropzone).
  //   2) First upload kicks off → we POST {action:'create_folder'} to
  //      Apps Script to create a per-customer sub-folder in Drive.
  //   3) For each file: POST {action:'init_upload', filename, size,
  //      folderId} to get a resumable upload URL.
  //   4) PUT file bytes straight to that resumable URL (browser → Google).
  //   5) When all files are done, drop the Drive folder URL into the
  //      hidden #CustomQuote-Drive input so Nick sees the link in the
  //      submission email.
  //
  // We use Content-Type: text/plain on the Apps Script POSTs so the
  // browser treats them as "simple" CORS requests (no preflight). Apps
  // Script still sees the raw JSON via e.postData.contents.
  (function() {
    // Shopify's {% javascript %} blocks are NOT processed by Liquid, so we
    // can't interpolate {{ section.settings.apps_script_url }} here. Instead
    // we read it from a data-* attribute on the uploader <div>, which Liquid
    // DID render when the page was served.
    var uploader = document.querySelector('.custom-quote__uploader');
    if (!uploader) return;
    var APPS_SCRIPT_URL = uploader.getAttribute('data-apps-script-url') || '';
    if (!APPS_SCRIPT_URL) return;

    var fileInput      = document.getElementById('CustomQuote-Files');
    var dropzone       = document.getElementById('CustomQuote-Dropzone');
    var fileList       = document.getElementById('CustomQuote-FileList');
    var statusEl       = document.getElementById('CustomQuote-UploadStatus');
    var driveInput     = document.getElementById('CustomQuote-Drive');             // visible, customer-editable fallback
    var driveHidden    = document.getElementById('CustomQuote-DriveFolderUrl');    // hidden, auto-populated on upload
    var driveNameHidden = document.getElementById('CustomQuote-DriveFolderName');  // hidden folder name (for Quote Tool auto-load)
    var form           = document.getElementById('CustomQuoteForm');
    var submitBtn      = form ? form.querySelector('button[type=submit]') : null;
    var nameInput      = document.getElementById('CustomQuote-Name');
    if (!fileInput || !dropzone || !form) return;

    // Queue of File objects that haven't been uploaded yet.
    var pending = [];
    // Drive folder (created on first file) — reused for the whole session.
    var folder = null;
    var uploading = false;

    function setStatus(msg, kind) {
      statusEl.textContent = msg || '';
      statusEl.classList.remove('is-error', 'is-done');
      if (kind) statusEl.classList.add('is-' + kind);
    }

    function fmtBytes(n) {
      if (n < 1024) return n + ' B';
      if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
      if (n < 1024 * 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + ' MB';
      return (n / 1024 / 1024 / 1024).toFixed(2) + ' GB';
    }

    function postJson(body) {
      // text/plain keeps this a CORS "simple" request (no preflight).
      return fetch(APPS_SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(body),
      }).then(function(r) { return r.json(); });
    }

    function ensureFolder() {
      if (folder) return Promise.resolve(folder);
      var name = (nameInput && nameInput.value ? nameInput.value : 'quote').trim() || 'quote';
      return postJson({ action: 'create_folder', customerName: name })
        .then(function(res) {
          if (!res.ok) throw new Error(res.error || 'Folder create failed');
          folder = res;
          // Write the Drive folder link to the HIDDEN field (not the visible
          // one) so Nick's email and the Sheet still receive it, but the
          // customer never sees "our" Drive URL in their browser. The visible
          // input stays theirs to use as a fallback link.
          if (driveHidden) driveHidden.value = res.folderUrl || '';
          if (driveNameHidden) driveNameHidden.value = res.folderName || '';
          return res;
        });
    }

    function uploadOne(file, row) {
      var progressEl = row.querySelector('.cqf-progress');
      progressEl.textContent = 'preparing…';
      return ensureFolder().then(function(f) {
        return postJson({
          action: 'init_upload',
          filename: file.name,
          size: file.size,
          mimeType: file.type || 'application/octet-stream',
          folderId: f.folderId,
        });
      }).then(function(res) {
        if (!res.ok) throw new Error(res.error || 'Init failed');
        return new Promise(function(resolve, reject) {
          var xhr = new XMLHttpRequest();
          // Track whether all bytes reached Google. If they did and the
          // response read fails (CORS quirk on resumable uploads), the file
          // is in fact safely in Drive — we treat that as success.
          var reachedEnd = false;
          var settled    = false;
          function markDone() {
            if (settled) return;
            settled = true;
            progressEl.textContent = 'done';
            progressEl.classList.add('is-done');
            resolve();
          }
          function markFail(msg) {
            if (settled) return;
            settled = true;
            reject(new Error(msg));
          }
          xhr.open('PUT', res.uploadUrl, true);
          xhr.upload.onprogress = function(ev) {
            if (!ev.lengthComputable) return;
            var pct = Math.round((ev.loaded / ev.total) * 100);
            progressEl.textContent = pct + '%';
            if (ev.loaded >= ev.total) reachedEnd = true;
          };
          xhr.upload.onload = function() {
            // Body fully transmitted. Drive has the bytes at this point even
            // if the subsequent response read is blocked by CORS.
            reachedEnd = true;
          };
          xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
              markDone();
            } else if (reachedEnd) {
              // Non-2xx but we know all bytes landed — still counts as a save.
              markDone();
            } else {
              markFail('Upload failed (' + xhr.status + ')');
            }
          };
          xhr.onerror = function() {
            if (reachedEnd) {
              // CORS read-failure on the response, but bytes arrived. Trust it.
              markDone();
            } else {
              markFail('Network error during upload');
            }
          };
          xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
          xhr.send(file);
        });
      }).catch(function(err) {
        progressEl.textContent = 'error';
        progressEl.classList.add('is-error');
        throw err;
      });
    }

    function addRow(file) {
      var li = document.createElement('li');
      var nm = document.createElement('span');
      nm.className = 'cqf-name';
      nm.textContent = file.name + ' · ' + fmtBytes(file.size);
      var pr = document.createElement('span');
      pr.className = 'cqf-progress';
      pr.textContent = 'queued';
      li.appendChild(nm);
      li.appendChild(pr);
      fileList.appendChild(li);
      fileList.hidden = false;
      return li;
    }

    function setSubmitDisabled(v) {
      if (submitBtn) submitBtn.disabled = !!v;
    }

    function runQueue() {
      if (uploading) return;
      if (pending.length === 0) return;
      uploading = true;
      setSubmitDisabled(true);
      setStatus('Uploading… keep this tab open until it finishes.');

      var chain = Promise.resolve();
      var hadError = false;
      pending.forEach(function(item) {
        chain = chain.then(function() {
          return uploadOne(item.file, item.row);
        }).catch(function(err) {
          hadError = true;
          console.error('[CustomQuote upload]', err);
          return null; // keep going so the rest still try
        });
      });
      chain.then(function() {
        pending = [];
        uploading = false;
        setSubmitDisabled(false);
        if (hadError) {
          setStatus('Some files failed to upload. You can retry, or paste a Drive link as a fallback below.', 'error');
        } else {
          setStatus('All files uploaded ✓  You can submit the form.', 'done');
        }
      });
    }

    function queueFiles(files) {
      for (var i = 0; i < files.length; i++) {
        var f = files[i];
        if (!f) continue;
        var row = addRow(f);
        pending.push({ file: f, row: row });
      }
      runQueue();
    }

    fileInput.addEventListener('change', function() {
      if (fileInput.files && fileInput.files.length) {
        queueFiles(fileInput.files);
        // Reset so picking the same file again re-fires change.
        fileInput.value = '';
      }
    });

    // Drag-and-drop support on the dropzone label.
    ['dragenter', 'dragover'].forEach(function(ev) {
      dropzone.addEventListener(ev, function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'dragend', 'drop'].forEach(function(ev) {
      dropzone.addEventListener(ev, function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.remove('is-dragover');
      });
    });
    dropzone.addEventListener('drop', function(e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        queueFiles(e.dataTransfer.files);
      }
    });

    // On form submit:
    //   1) Block if files are still uploading.
    //   2) Hold the submit, POST to Apps Script's log_submission action,
    //      wait for it to complete, THEN let the native contact form fire.
    //      This is more reliable than sendBeacon / keepalive fetch because
    //      the request has a normal (non-unload) lifecycle and shows up in
    //      DevTools Network for debugging.
    //   3) If the Apps Script call fails, still submit the form so Nick
    //      gets the email — the Sheet row is a nice-to-have, the email
    //      notification is the non-negotiable.
    form.addEventListener('submit', function(e) {
      if (uploading) {
        e.preventDefault();
        setStatus('Hold on — your files are still uploading.', 'error');
        return;
      }
      // If we've already logged (second pass after form.submit() below), let
      // the native submit proceed.
      if (form.dataset.cqfLogged === 'true') return;

      e.preventDefault();
      setSubmitDisabled(true);
      setStatus('Sending…');

      var didSubmit = false;
      function submitOnce() {
        if (didSubmit) return;
        didSubmit = true;
        form.dataset.cqfLogged = 'true';
        // Second submit; this time our handler short-circuits and the form
        // goes to Shopify's contact endpoint as usual.
        form.submit();
      }

      // Hard timeout: if the Apps Script calls don't come back in 10s (ad
      // blocker, network hiccup, cold-start), submit the form anyway so the
      // customer isn't stuck. Nick still gets the email.
      var timeoutId = setTimeout(function() {
        console.warn('[CustomQuote log] Timeout — submitting form without Sheet log');
        submitOnce();
      }, 10000);

      // If the folder was created before the customer typed their name it'll
      // be named "quote_<timestamp>". Rename it now that we have the real name.
      // This is a best-effort POST to Apps Script — same call pattern as
      // log_submission, which reliably works from the submit handler.
      var renameStep = Promise.resolve();
      var customerName = readField('name');
      if (folder && customerName && (folder.folderName || '').slice(0, 6) === 'quote_') {
        renameStep = postJson({
          action: 'rename_folder',
          folderId: folder.folderId,
          customerName: customerName,
        }).then(function(res) {
          if (res && res.ok && res.folderName) {
            folder.folderName = res.folderName;
            if (driveNameHidden) driveNameHidden.value = res.folderName;
          }
        }).catch(function() { /* best-effort — proceed even if rename fails */ });
      }

      renameStep.then(function() {
        logSubmissionToSheet().then(function() {
          clearTimeout(timeoutId);
          submitOnce();
        });
      });
    });

    function readField(name) {
      var el = form.querySelector('[name="contact[' + name + ']"]');
      if (!el) return '';
      if (el.type === 'checkbox') return el.checked ? el.value : '';
      if (el.tagName === 'SELECT') return el.value;
      // For radio groups we need the checked one specifically.
      var radios = form.querySelectorAll('input[type="radio"][name="contact[' + name + ']"]');
      if (radios.length) {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked) return radios[i].value;
        }
        return '';
      }
      return el.value || '';
    }

    function logSubmissionToSheet() {
      // Prefer the hidden field (auto-populated by the uploader). Fall back
      // to whatever the customer pasted into the visible field. Empty
      // string if both are blank — the row still logs, just without a
      // folder link.
      var folderUrl = '';
      if (driveHidden && driveHidden.value) folderUrl = driveHidden.value;
      else if (driveInput && driveInput.value) folderUrl = driveInput.value;
      var folderName = (driveNameHidden && driveNameHidden.value) || '';

      var payload = {
        action: 'log_submission',
        customerName:       readField('name'),
        email:              readField('email'),
        channel:            readField('fulfillment_channel'),
        etsyUsername:       readField('etsy_username'),
        projectDescription: readField('project_description'),
        quantity:           readField('quantity'),
        // shipmentSize was removed from the visible form 2026-04-25 — Nick
        // eyeballs it from the actual files. Sent as blank so the column
        // in the Sheet stays consistent with older rows.
        shipmentSize:       '',
        presupported:       !!readField('presupported'),
        folderUrl:          folderUrl,
        folderName:         folderName,
        notes:              readField('notes'),
        marketingOptIn:     !!readField('marketing_opt_in'),
        source:             readField('_source') || 'custom-quote-form',
      };
      var body = JSON.stringify(payload);

      // Plain fetch with await. We're in a preventDefault()'d submit, so the
      // page isn't navigating yet — no need for sendBeacon or keepalive.
      // text/plain keeps this a CORS "simple" request (no preflight).
      //
      // We always resolve (never reject) so the form.submit() in the caller
      // still fires even if the Sheet write fails. The email notification is
      // Nick's safety net — losing a Sheet row is recoverable, losing the
      // email means a customer gets dropped on the floor.
      return fetch(APPS_SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: body,
      }).then(function(r) {
        return r.json().catch(function() { return null; });
      }).then(function(res) {
        if (res && res.ok === false) {
          console.warn('[CustomQuote log] Apps Script returned error:', res.error);
        } else if (res && res.logged) {
          console.log('[CustomQuote log] Logged row', res.rowNumber);
        } else {
          console.log('[CustomQuote log] Response:', res);
        }
      }).catch(function(err) {
        // Don't block the form submit — just log and continue.
        console.error('[CustomQuote log]', err);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
